import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Carousel from "./Carousel";

const Home = () => {
  const [homedata, setHomeData] = useState([]);
  useEffect(() => {
    fetch("https://kvrstarlightmedicalacademy.com/api/home.php")
      .then((response) => response.json())
      .then((data) => setHomeData(data));
  }, []);
  return (
    <div>
      <Carousel />
      <div
        style={{ display: "flex", justifyContent: "end", marginBottom: "20px" }}
      >
        <button
          style={{
            backgroundColor: "black",
            borderRadius: "8px",
            padding: "5px 10px",
            fontSize: "16px",
          }}
        >
          <Link to="/aboutus" style={{ color: "white" }}>
            Read More...
          </Link>
        </button>
      </div>
      {
        homedata?.map((element)=>(
      <div class="container">
        <h2 style={{ color: "#0460a4" }}>
         {element.heading}
        </h2>

        <p style={{ textAlign: "justify" }}>
          {element.para}
        </p>
      </div>
        ))
      }

    </div>
  );
};

export default Home;
